import { jsx } from "react/jsx-runtime";
import { Box, Inline } from "braid-design-system";
import { CustomHeaderDesktopLink } from "./HeaderLink.mjs";
import { root, nav, isActive } from "./DesktopNavigation.css.mjs";
const DesktopNavigation = ({
  activeTabId,
  items,
  linkRenderer
}) => /* @__PURE__ */ jsx("div", { className: root, children: /* @__PURE__ */ jsx(
  Box,
  {
    component: "nav",
    role: "navigation",
    display: "flex",
    alignItems: "center",
    height: "full",
    overflow: "hidden",
    className: nav,
    "data-test": "desktop-header-nav",
    children: /* @__PURE__ */ jsx(Inline, { space: "medium", children: items.map(({ id, label, href, ...headerNavItemProps }, index) => /* @__PURE__ */ jsx(
      CustomHeaderDesktopLink,
      {
        active: id === activeTabId,
        activeStyle: isActive,
        linkRenderer,
        href,
        "data-analytics": headerNavItemProps["data-analytics"],
        "data-test": headerNavItemProps["data-test"],
        analyticsEvent: headerNavItemProps.analyticsEvent,
        children: label
      },
      `desktop-nav-item-${index}`
    )) })
  }
) });
export {
  DesktopNavigation
};
